import { createFileRoute } from '@tanstack/react-router'
import { JobRolesPage } from '@/features/job-roles'

export const Route = createFileRoute('/job-roles')({
  component: JobRolesPage,
})
